import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
} from "reactstrap";
import { API_URL, timeToast } from "../../../Constant";
import { toast } from "react-toastify";
import { StatusDataAkunBaru } from "../../../Constant/StatusData";
import {
  APIUpdateSuccessMsg,
  getItemEditSuccessMsg,
} from "../../../Constant/Message";
import DATA_TYPE from "../../../Constant/DataType";
import { useThemeContext } from "../../../Context/ThemeContext";
import { SelectionField } from "../../../CommonElements";
toast.configure();

const EditStatusDaftarStatus = ({
  editStatusModalOpen,
  toggleEditStatusModal,
  selectedAkun,
  getRencImp,
  axiosInstance,
}) => {
  const [waitingForSubmit, setWaitingForSubmit] = useState(false);
  const [formData, setFormData] = useState({
    id_anggaran_bulanan_unit_kerja: "",
    id_jenis_pembayaran: "",
    id_sub_kegiatan: "",
    id_satuan: "",
    id_akun: "",
    id_sumber_dana: "",
    id_jenis_kegiatan: "",
    status_akun: "",
  });

  const { themeContext } = useThemeContext();

  useEffect(() => {
    if (selectedAkun) {
      setFormData({
        id_anggaran_bulanan_unit_kerja:
          selectedAkun.id_anggaran_bulanan_unit_kerja,
        id_jenis_pembayaran: selectedAkun.id_jenis_pembayaran,
        id_sub_kegiatan: selectedAkun.id_sub_kegiatan,
        id_satuan: selectedAkun.id_satuan,
        id_akun: selectedAkun.id_akun,
        id_sumber_dana: selectedAkun.id_sumber_dana,
        id_jenis_kegiatan: selectedAkun.id_jenis_kegiatan,
        status_akun: selectedAkun.status_akun,
      });
    }
  }, [selectedAkun]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setWaitingForSubmit(true);
      const response = await axiosInstance.put(
        `${API_URL}rencanaimp/${selectedAkun.pk}/`,
        formData
      );

      if (response.status === 200) {
        console.log(APIUpdateSuccessMsg);
        toast.success(getItemEditSuccessMsg(DATA_TYPE.Akun), {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: timeToast,
        });
        toggleEditStatusModal();
        getRencImp();
        let timer = setTimeout(() => setWaitingForSubmit(false), 1000);
        return () => clearTimeout(timer);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
      setWaitingForSubmit(false);
    }
  };

  return (
    <Modal isOpen={editStatusModalOpen} toggle={toggleEditStatusModal}>
      <ModalHeader toggle={toggleEditStatusModal}>Edit Status Akun</ModalHeader>
      <ModalBody>
        <Form>
          <SelectionField
            state={StatusDataAkunBaru}
            label={"Status Akun"}
            name={"status_akun"}
            onChange={handleChange}
            value={formData.status_akun}
            options={StatusDataAkunBaru}
            optionsName={"nama_status"}
            optionsValue={"id"}
          />
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={waitingForSubmit}
        >
          Submit
        </Button>{" "}
        <Button color="secondary" onClick={toggleEditStatusModal}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditStatusDaftarStatus;
